import { Inventory } from "@mui/icons-material";

const app_modules = {
    dashboard: {
        app_name: "Dashboard",
        modules: {
            dashboard: "Dashboard",
        }
    },
    master: {
        app_name: "Masters",
        modules: {
            master: "Masters",
            category: "Category",
            brand: "Brand",
            hsn_code: "HSN Code",
            gst: "GST",
            item: "Item",
            user_types: "User Types",
            team: "Team",
            organisation: "Organisation",
            department: "Department",
            user: "User",
            module: "Module",
            customer:"Customer",
            attribute:"Attributes",
            tag:"Tags",
        }
    },
    user_management: {
        app_name: "User Management",
        modules: {
            organisation: "Organization",
            department: "Department",
            team: "Team",
            user: "User",
            module: "Module",
            user_types: "User Types",
        }
    },
    template: {
        app_name: "Template",
        modules: {
            template: "Template",
           
        }
    },
    quotation: {
    app_name: "Quotation",
    modules: {
        quotation: "Quotation",   
    }
}


   
}
const action_options = {
    create: "Create",
    view: "View",
    update: "Update",
}

export { app_modules, action_options };